import API from "../apiConfig";


const root = 'admin/meta'

export default {
    // types api
    fetchTypes(page = 1, limit = 10) {
        return API.get(`${root}?page=${page}&limit=${limit}`);
    },
    addMetaTags(data) {
        return API.post(`${root}/create`, data);
    },
    updateMetaTags(id, data) {
        return API.post(`${root}/update/${id}`, data);
    },
    deleteMetaTags(id) {
        return API.delete(`${root}/${id}`);
    }
}